<template> 
  <div class="approval container">
    <div class="row card-panel" style="padding: 30px;">
      <div class="col-12" v-if="!successApproved && !successDenied">
        <div class="row" style="margin-top: 75px">
          <div class="col-12 center">
            <h2 class="teal-text">Approving.</h2>
            <p>One moment please...</p>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="successApproved">
        <div class="row" style="margin-top: 35px">
          <div class="col-12 center">
              <span class="material-icons afas-gold-text" style="font-size: 100px;">
            check_circle
            </span>
            <h2 class="teal-text">Approved!</h2>
            <p>The booking has been approved.</p>
          </div>
        </div>
        <div class="row" style="margin-top: 20px">
          <div class="col-12 center">
              <table>
                  <tbody>
                      <tr>
                          <td>Employee: </td>
                          <td>{{ this.selectedBooking.employee }}</td>
                      </tr>
                      <tr>
                          <td>Office: </td>
                          <td>{{ this.selectedBooking.location }}</td>
                      </tr>
                      <tr>
                          <td>Date: </td>
                          <td>{{ day + " " + time }}</td>
                      </tr>
                      <tr>
                          <td>Shift: </td>
                          <td>{{ this.selectedBooking.shift }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>
      </div>
       <div class="col-12" v-if="successDenied">
        <div class="row" style="margin-top: 35px">
          <div class="col-12 center">
           <span class="material-icons" style="font-size: 100px; color: red;">
            highlight_off
            </span>
            <h2 class="teal-text">Denied!</h2>
            <p>The booking will be denied.</p>
          </div>
        </div>
        <div class="row" style="margin-top: 20px">
          <div class="col-12 center">
              <table>
                  <tbody>
                      <tr>
                          <td>Employee: </td>
                          <td>{{ this.selectedBooking.employee }}</td>
                      </tr>
                      <tr>
                          <td>Office: </td>
                          <td>{{ this.selectedBooking.location }}</td>
                      </tr>
                      <tr>
                          <td>Date: </td>
                          <td>{{ day + " " + time }}</td>
                      </tr>
                      <tr>
                          <td>Shift: </td>
                          <td>{{ this.selectedBooking.shift }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>
        <div v-if="showReason" class="row" style="margin-top: 20px">
            <div class="col-12 input-field">
                <textarea  style="height: 130px;" v-model="reason" class="materialize-textarea" id="text-area-why" maxlength="200"></textarea>
                <label for="text-area-why">Why is this reservation being denied?</label>
            </div>
        </div>
        <div v-if="showReason" class="row margin-top-20">
          <div class="col-12">
            <button type="button" class="waves-effect waves-light btn" @click.prevent="confirmDeny()">Confirm</button>
          </div>
        </div>
        <div v-if="denySuccess" class="row" style="margin-top: 20px">
            <div class="col-12">
                <div class="materialert success">
                    <div class="material-icons">check</div>
                    De reservering is afgewezen en verwijderd.
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
import { mapGetters, mapActions } from 'vuex';
import moment from "moment";
export default {
  name: "Approve",
  data() {
    return {
      feedback: null,
      successApproved: false,
      successDenied: false,
      day: null,
      time: null,
      reason: null,
      showReason: null,
      denySuccess: false
    };
  },
  computed: {
    ...mapGetters(['selectedBooking']),
  },
  methods: {
    ...mapActions(['approveBooking', 'denyBooking', 'setBooking']),
    async approveTheBooking() {
        var info ={
            bookingid: this.$route.params.bookingid,
            officeid: this.$route.params.officeid,
            status:  this.$route.params.status,
        }
        if(info.status == 1){
            await this.approveBooking(info)
            this.feedback = "This booking is approved."
            await this.setBooking(this.$route.params.bookingid)
            console.log(this.selectedBooking);
            this.time   = moment(this.selectedBooking.timestamp).format("Do MMM"),
            this.day    = moment(this.selectedBooking.timestamp).format("dddd"),
            this.successApproved    = true;
            this.successDenied      = false;
            this.showReason         = false;
        } else {
            this.feedback = "This booking is denied."
            await this.setBooking(this.$route.params.bookingid)
            this.time   = moment(this.selectedBooking.timestamp).format("Do MMM"),
            this.day    = moment(this.selectedBooking.timestamp).format("dddd"),
            this.successApproved    = false;
            this.successDenied      = true;
            this.reason             = undefined;
            this.showReason         = true;
        }
    },
    async confirmDeny(){
        var deny_info ={
            bookingid: this.$route.params.bookingid,
            officeid: this.$route.params.officeid,
            status:  this.$route.params.status,
            reason: this.reason,
        }
        await this.denyBooking(deny_info);
        this.denySuccess        = true;
        this.showReason         = false;
    }
  },
  created() {
    this.approveTheBooking();
  },
};
</script>

<style>
.approval {
  max-width: 400px;
  margin-top: 60px;
}
.approval h2 {
  font-size: 1.4em;
}
.approval .field {
  margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/approve/Approve.vue